module.exports = __webpack_public_path__ + "static/media/05.1eb5c39e.mp3";